export enum CivilCaseTabType {
  Charge = 0,
  Document = 1,
  Party = 2,
  CoDefendant = 3,
  CourtDate = 4,
  Bond = 5,
}
